module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/loader-ecac8103781de4f47c30013590518a43.svg";